export enum CPProgramWeekOneStep {
    WhatIsMindfulnessStep = 'what-is-mindfulness',
    WhatDoesMindfulnessDoStep = 'what-does-mindfulness-do',
    MindfulnessFAQStep = 'mindfulness-faq',
    MindfulnessImprovementsTopicsStep = 'how-do-you-want-to-use-mindfulness',
    MindfulnessExerciseStep = 'mindfulness-exercise',
}

export interface MindfulnessImprovementsTopicItem {
    definition: string;
    description?: string;
}

export interface MindfulnessImprovementsTopics {
    workImprovementsTopics: string[];
    workImprovementsAdditionalInfo: string;
    lifeImprovementsTopics: string[];
    lifeImprovementsAdditionalInfo: string;
}

export interface ChangeMindfulnessImprovementsFieldActionArguments {
    field: string;
    value: string;
}
